<template>
  <div v-if="currentTable">
    <button class="btn btn-link" @click="currentTable = null">
      <span class="mr-1">&lt;&lt;</span>voltar
    </button>
    <br>
    
    <small style="color: #051B30" class="mr-2">Colunas:</small>
    <span class="option-column">
      <small v-for="column in currentTable.columns" :key="column.id">
        {{ column.name }}
      </small>
    </span>
    <hr>
  
    <div class="row">
      <div class="col-md-2">
        <label class="float-right">Valor</label>
      </div>
      
      <div class="col-md-4  ">
        <select v-model="field.value_index" class="form-control">
          <option :value="column.index" v-for="column in currentTable.columns" :key="column.id">
            {{ column.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
  
  <div v-else>
    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder="Pesquisar por Nome"
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>
      
      <button
        class="col-md-1 ml-2 btn-sm btn-outline"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>
      
      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>
    
    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query"
          :amount-changed="updateNumberOfBadges"
          :filters="[filterPublic, filterPeriodType, filterStartDate, filterEndDate]"
          @clearBadge="find()"
          @clearAllBadges="find()"
        />
      </div>
    </div>
    
    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-3">
          <label for="rf-public">Publico?</label>
          <select v-model="query.public" id="rf-public" class="form-control">
            <option v-for="opt in filterPublic.table" :value="opt.value" :key="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>
        
        <div class="col-md-3">
          <label for="rf-period-type">Tipo de período</label>
          <select v-model="query.periodType" id="rf-period-type" class="form-control">
            <option v-for="opt in filterPeriodType.table" :value="opt.value" :key="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>
        
        <div class="col-md-3">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>
        
        <div class="col-md-3">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      
      </div>
    </template>
    <hr>
    
    <div class="row">
      <div class="col-sm-12">
        
        <div class="row mt-4">
          <div class="col-md-12">
            <strong>
              {{infoTotalModels}}
            </strong>
          </div>
        </div>
        
        <table class="table table-borderless table-align table-h51">
          <thead>
          <tr>
            <th>Nome</th>
            <th>Descrição</th>
            <th>Público</th>
            <th>Criado por</th>
            <th>Criado em</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="table in tables" :key="table.id">
            <td>{{ table.name }}</td>
            <td>
              <span class="truncate-0">{{ table.description }}</span>
            </td>
            <td>{{ table.public ? 'Sim' : 'Não' }}</td>
            <td>{{ table.createdBy }}</td>
            <td>{{ table.createdAt | datetime }}</td>
<!--            <td><small><pre>{{ table }}</pre></small></td>-->
            <td>
              <button class="btn btn-outline" @click="show(table)">
                ver
              </button>
            </td>
          </tr>
          </tbody>
        </table>
        
        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>
      
      </div>
    </div>
  </div>
</template>

<script>
import BadgeFilters from '@/components/shares/BadgeFilters'
import ModelMapper from '@/mixins/ModelMapper'
import Pagination from '@/components/shares/specialTag/Pagination'

import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
import { Filter } from '@/models/filter'

export default {
  components: { BadgeFilters, ChevronDownIcon, Pagination, SearchIcon },
  computed: {
    tables() {
      return this.getModels || []
    }
  },
  created() {
    this.$set(this.query, 'public', '')
    this.$set(this.query, 'periodType', '')
    
    this.defaultModelSetting.updateQueryURL = true
    this.asyncTemplateSelect({
      byURL: true,
      pagination: true
    })
  },
  data: () => ({
    currentTable: null,
    filterEndDate: new Filter({
      key: 'endDate',
      label: 'Data final',
      type: 'date'
    }),
    filterPeriodType: new Filter({
      key: 'periodType',
      label: 'Tipo do período',
      table: [
        ['Atualização', 'updated_at'],
        ['Inclusão', '']
      ],
    }),
    filterPublic: new Filter({
      key: 'public',
      label: 'Public',
      table: [
        ['Todos', ''],
        ['Público', true],
        ['Privado', false]
      ]
    }),
    filterStartDate: new Filter({
      key: 'startDate',
      label: 'Data inicial',
      type: 'date'
    }),
    modelPathPrefix: 'custom_table',
    nameModel: 'Table',
  }),
  methods: {
    find() {
      this.asyncTemplateSelect()
    },
    show(table) {
      this.field.table_id = table.id
      this.currentTable = table
    }
  },
  mixins: [ModelMapper],
  name: 'ReferencedTable',
  props: {
    field: {
      required: true,
      type: Object
    }
  }
}
</script>

<style scoped>
.option-column small {
  color: #051B30;
  font-weight: 600;
  background-color: #8080802e;
  padding: 4px 8px;
  margin: 0 4px 0 0;
  border-radius: 2px;
}
</style>